import React from "react";
import { useModal } from "../../../context/ModalContext";
import { MODALS } from "../../../config/params";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";


const DuplicateAccountAlertModal = () => {
  const { openModal, closeModal } = useModal();
  const openContactModal = () => {
    openModal(MODALS.OVERDUE_CONTACT_MODAL);
    userActivityLogger(MIXPANEL_EVENTS.CONTACT_HOSPITAL_TRIGGERED, {
      referred_from: "account_confirmation_pop_up",
    });
  };
  const handleCancel = () => {
    closeModal();
  };

  return (
    <div className="flex flex-col w-full xl:w-[27rem]">
      <div className="flex justify-end cursor-pointer" onClick={handleCancel}>
        <CloseIcon/>
      </div>
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col items-center h-full my-4">
          <img
            className="h-[9rem] w-[9rem]"
            alt="confirm_dropoff_icon"
            src="/assets/icons/account-alert.png"
          />
          <div className="text-2xl font-bold text-center">
              Account Confirmation Needed
          </div>
          <div className="text-light-black text-center">
              We have multiple accounts for you in our system. To avoid any confusion and ensure accurate records,
              please call your home hospital to confirm the correct account.
          </div>
        </div>
        <div className="text-center">
          <StyledBookingFlowButton
            color="primary"
            size="small"
            className="w-full"
            onClick={openContactModal}
          >
              Contact Hospital
          </StyledBookingFlowButton>
        </div>
      </div>
    </div>
  );
};

export default DuplicateAccountAlertModal;
